import { cn } from "@/lib/utils";
export type WilsonMood = "thinking" | "writing" | "idle" | "still";
export function WilsonPresence({
  mood,
  className,
  title
}: {
  mood: WilsonMood;
  className?: string;
  title?: string;
}) {
  const a11y = title ? {
    role: "img" as const,
    "aria-label": title
  } : {
    "aria-hidden": true
  }; // boolean-naming-exempt: external contract — ARIA attribute
  return <svg viewBox="0 0 35 32" fill="currentColor" className={cn("h-[13px] w-auto flex-shrink-0 overflow-visible text-ink", (mood === "writing" || mood === "idle") && "wilson-breathe", className)} {...a11y} data-sentry-element="svg" data-sentry-component="WilsonPresence" data-sentry-source-file="WilsonPresence.tsx">
            <path d="M17.22 31.56C11.245 31.56 5.455 30.43 0 28.21L1.23499 25.395C6.29499 27.46 11.675 28.505 17.22 28.505C22.765 28.505 28.145 27.46 33.205 25.395L34.44 28.21C28.985 30.43 23.195 31.56 17.22 31.56Z" data-sentry-element="path" data-sentry-source-file="WilsonPresence.tsx" />
            <path d="M18.6752 0H21.9503L15.0352 20.535H11.7603L18.6752 0Z" data-sentry-element="path" data-sentry-source-file="WilsonPresence.tsx" />
            <g className={cn((mood === "thinking" || mood === "writing") && "wilson-eyes-glance", mood === "idle" && "wilson-eyes-blink")} data-sentry-element="g" data-sentry-source-file="WilsonPresence.tsx">
                <path d="M31.8202 0H28.6501V11.035H31.8202V0Z" data-sentry-element="path" data-sentry-source-file="WilsonPresence.tsx" />
                <path d="M5.80035 0H2.63037V11.035H5.80035V0Z" data-sentry-element="path" data-sentry-source-file="WilsonPresence.tsx" />
            </g>
        </svg>;
}